import React, { useEffect, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import axios from '../../../services/AxiosInstance';
import { getApiUrl } from '../../../utils/ApiUtils';
import { membershipError } from './OwnershipSection';

export default function EmploymentAccessControl({ companyId, user, canManage, onChanged }) {
    const [retain, setRetain] = useState(false);
    const [saved, setSaved] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    useEffect(() => { const value = !!user?.retain_after_employment; setRetain(value); setSaved(value); setError(''); }, [user]);
    if (!companyId || !user || !canManage) return null;
    const save = async () => {
        setBusy(true); setError('');
        try {
            await axios.put(getApiUrl(`${companyId}/users/${user.user_id}/employment-access`), { retainAfterEmployment: retain });
            setSaved(retain); onChanged?.();
        } catch (failure) { setError(membershipError(failure)); }
        finally { setBusy(false); }
    };
    return <div className="mt-4 pt-3 border-top">
        <h6>Åtkomst efter avslutad anställning</h6>
        <p>Företagstillgången tas bort när anställningen avslutas. Som ägare kan du besluta att den ska finnas kvar, till exempel för en extern administratör. Om du återkallar valet efter avslutad anställning tas tillgången bort direkt. Ägarskap påverkas inte.</p>
        <Form.Check id={`retain-access-${user.user_id}`} type="checkbox" label="Behåll företagstillgången efter avslutad anställning"
            checked={retain} disabled={busy} onChange={event => setRetain(event.target.checked)} />
        {error && <Alert className="mt-2" variant="danger">{error}</Alert>}
        <Button className="mt-2" variant="outline-primary" disabled={busy || retain === saved} onClick={save}>Spara åtkomstval</Button>
    </div>;
}
